'use client';

import { useEffect, useState } from 'react';
import { RightRailArticleAd } from '@/app_components/ads/RightRailArticleAd';
import { RightRailFlex } from '@/app_components/ads/RightRailFlex';
import { AbTest } from '@/app_components/common/AbTest';
import { RightRailPromo } from '@/app_components/PianoTemplateContainers/PromoInventory/RightRailPromo';
import { Breakpoints, useMediaQuery } from '@/app_lib/hooks/useMediaQuery';
import { usePaywall } from '@/app_lib/providers/PaywallProvider';
import { ContentPlacement } from '@/app_lib/types/analytics';
import { baseAdPlacementConfig } from '@/app_lib/utils/ads';

export const RightRail = () => {
  const isDesktop = useMediaQuery(Breakpoints.Desktop);
  const {
    paywallState: { paywallCheck },
  } = usePaywall();

  const [stickyRightRailOffset, setStickyRightRailOffset] = useState(0);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const prePaywallContainer = document.querySelector('.article-content');
    const prePaywallCount = prePaywallContainer?.querySelectorAll(':scope > p').length;

    const paywallContainer = document.querySelector('.paywall');
    const paywallCount = paywallContainer?.querySelectorAll(':scope > p').length;

    const paragraphCount = (prePaywallCount || 0) + (paywallCount || 0);

    const articleContentElement = document.querySelector('.container-content');
    const articleContentWrapperElement = document.querySelector('.container-content-wrapper');

    // Sets the offset of the large sticky right rail ad to place below the first instream ad
    const updateOffset = () => {
      if (
        !(
          isDesktop &&
          // The sticky ad only renders if there are at least 2 instream ads to show
          paragraphCount >= baseAdPlacementConfig.firstAdPlacement + baseAdPlacementConfig.desktopAdFrequency &&
          paywallCheck === 'no-paywall'
        )
      ) {
        return;
      }

      // Class is set in InStreamAd.tsx
      const firstInstreamAdContainer = document.querySelector('.firstInstreamAdContainer');

      const articleContentGap = 24; // Gap for the article content (gap-xl)
      const staticRightRailHeight = 250; // Subtracted from offset to account for the static Right Rail Ad

      if (firstInstreamAdContainer) {
        const firstInstreamAdContainerBottom = firstInstreamAdContainer.getBoundingClientRect().bottom;
        const articleContainerTop = articleContentElement?.getBoundingClientRect().top || 0;
        const offset = firstInstreamAdContainerBottom - articleContainerTop - staticRightRailHeight + articleContentGap;
        setStickyRightRailOffset(offset);
      }
    };

    let observer: MutationObserver;
    if (articleContentWrapperElement) {
      observer = new MutationObserver(() => updateOffset());
      observer.observe(articleContentWrapperElement, { childList: true, subtree: true });
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [paywallCheck, isDesktop]);

  if (!isDesktop) {
    return null;
  }

  return (
    <div
      className='relative flex flex-col items-center h-full overflow-x-clip'
      data-cy={ContentPlacement.ArticleRightRail}
    >
      <div className='relative'>
        <RightRailFlex
          index={1}
          sticky={false}
        />
        {/* Top is calculated based on height of Static Right Rail Ad (250px) and the Gap (40px)  */}
        <div className='absolute left-0 top-[290px]'>
          <AbTest flagName='promo_right_rail'>
            <RightRailPromo />
          </AbTest>
        </div>
      </div>
      {stickyRightRailOffset !== 0 && (
        // Only render after offset is calculated to prevent Optimizely tracking issues
        <RightRailArticleAd
          index={1}
          marginTop={stickyRightRailOffset}
          sticky={true}
        />
      )}
    </div>
  );
};
